// extracted by mini-css-extract-plugin
module.exports = {"root":"InsurancePlusSign_root__3QpDt"};